<input [type]="type" class="form-control" placeholder="{{placeholder}}" [formControl]="control"
    [attr.min]="min" [attr.max]="max"
    [ngClass]="{ 'is-invalid':  control.invalid && (control.touched || submitted) }" (input)="onInput($event)" />

<div *ngIf="control.invalid && (control.touched || submitted)" class="invalid-feedback">
    <div *ngIf="control.errors?.['invalidDate']">{{invalidMessage}}</div>
    <div *ngIf="!control.errors?.['invalidDate'] && control.errors?.['required']">{{errorMessage}}</div>
</div>
